export default __webpack_public_path__ + "static/media/ISMO CLASS-4 EXAM PATTERN 2026-27.5c214777.pdf";